import { HttpConnector } from 'src/modules/sm-base/models/http-connector.model';

export class RestEndpoint {
    url: string;

    constructor(url: string) {
        this.url = url;
    }

    static getUrl(): string {
        return "";
    }

    static main(): HttpConnector {
        return new HttpConnector(RestEndpoint.getUrl());
    }

    get(): HttpConnector {
        return new HttpConnector(this.url);
    }

}